<template>
    <div class="cs-block cs-footer-menu-block">
        <div class="cs-base-block">
            <div class="container">
                <div class="logo">
                    <img :src="data.logo" alt="" />
                </div>            
                <div class="row">
                    <div v-for="(m1, m1i) in menu" :key="`menu-${m1i}`" class="col-sm-6 col-md-4 col-lg-3">
                        <div class="cs-fm-m1">
                            <div class="cs-fm-m1-title">
                                <a :href="m1.url">{{ m1.title }}</a>
                            </div>
                            <div class="cs-fm-m1-children">
                                <span v-for="(m2, m2i) in m1.children" :key="`menu-${m1i}-${m2i}`">
                                    <div class="cs-fm-m2-title">
                                        <a :href="m2.url">{{ m2.title }}</a>
                                    </div>
                                    <div class="cs-fm-m2-children">
                                        <span v-for="(m3, m3i) in m2.children" :key="`menu-${m1i}-${m2i}-${m3i}`">
                                            <div class="cs-fm-m3-title">
                                                •
                                                <a :href="m3.url">{{ m3.title }}</a>
                                            </div>
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contacts">
                    <span v-html="data.contacts"></span>
                </div>
                <div class="icons">
                    <a v-for="(icon, key) in data.icons" :key="key" :href="icon.link">
                        <div class="cs-image-container cs-image-ratio-1x1">
                            <img :src="icon.icon" loading="lazy" :alt="icon.link" />
                        </div>
                    ></a>
                </div>
                <div class="copyright">
                    <span v-html="data.copyright"></span>
                </div>
            </div>
        
        </div>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    components: {
        MenuItem: () => import('../blocks_components/MenuBlockItem.vue')
    },
    data() {
        return {
            menu: [],
            catalog: [],
            info: [],
            labels: {
                catalog: 'Catalog',
                information: 'Information',
                contacts: 'Contacts',
                email: 'Email: ',
                schedule: 'Work schedule: '
            }
        }
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        homeUrl() {
            return window.location.origin
        },
    },
    methods: {
    },
    mounted() {
        if(data.menu)this.menu = Object.values(data.menu)
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';
.cs-block.cs-footer-menu-block {
    background: #00274f;
    .logo {

        margin-bottom:30px;
        
        img{
            width:100%;
            max-width:100px;
        }
    }
    .contacts{
        margin-top:30px;
        color:white;
    }
    a{
        text-decoration: none;
    }
    .cs-fm-m1-title {
        font-size: 1.5rem;
        font-weight: 900;
        a {
            color: #ddd;
            &:hover {
                color: #c0c0c0;
            }
        }
    }

    .cs-fm-m2-title {
        margin-top: 15px;
        font-size: 1.2rem;
        letter-spacing: 0.3px;
        a {
            color: white;
            &:hover {
                color: #c0c0c0;
            }
        }
    }

    .cs-fm-m3-title {
        padding:5px 0;
        font-size: 1rem;
        color: white;
        a {
            color: white;
            &:hover {
                color: #c0c0c0;
            }
        }
    }
    .copyright {
        color: #ddd;
        font-size: 0.8rem;
        margin-top: 30px;
    }


    .icons {
        display: flex;
        justify-content: flex-start;
        margin-top: 30px;
        
        a {
            width: 20px;
            height: 20px;
            display: block;
            margin-right: 15px;
        }

    }
}

</style>
